import React from "react";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { IoCloseCircleOutline } from "react-icons/io5";
export default function FacingProblem({ popUpInitialValue,image, closeThisPopUP }) {
  const { PopupStore, UserStore } = useStores();

  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        <div onClick={() => closeThisPopUP} className="absolute w-screen h-[50vh] gil-reg z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-10">
          <div onClick={(e) => e.stopPropagation()} className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-2xl items-center md:w-[50%] lg:w-[50%] w-[90%] h-[50%] md:h-[55%] lg:h-[75%] m-auto shadow-lg overflow-y-auto no-scrollbar">
            <div className="flex flex-col justify-center   h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
              <IoCloseCircleOutline
                className="text-primary absolute text-2xl lg:text-4xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />

              <img src={image} alt="server issue" className="m-5 mx-auto w-[70%]  " />
              <h4 className="text-center mt-5 md:text-lg mx-5">
                We're Upgrading for You! We're working on making Reaidy.io
                better. <br /> Please check back soon.
              </h4>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}

